import React from 'react';
import { st, classes } from './FullScreenModalLayout.st.css';
import { FullScreenModalLayoutProps } from './FullScreenModalLayout.types';
import { BaseModalLayout } from '../BaseModalLayout';
import { FullScreenModalLayoutHeader } from './components/FullScreenModalLayoutHeader';
import { FullScreenModalLayoutContent } from './components/FullScreenModalLayoutContent';
import { FullScreenModalLayoutFooter } from './components/FullScreenModalLayoutFooter';
import { DATA_HOOKS } from './FullScreenModalLayout.constants';

const FullScreenModalLayout = ({
  dataHook,
  className,
  children,
  ...restProps
}: FullScreenModalLayoutProps) => {
  return (
    <BaseModalLayout
      dataHook={dataHook || DATA_HOOKS.fullScreenModalLayoutRoot}
      className={st(classes.root, className)}
      {...restProps}
    >
      {children}
    </BaseModalLayout>
  );
};

FullScreenModalLayout.displayName = 'FullScreenModalLayout';

FullScreenModalLayout.Header = FullScreenModalLayoutHeader;
FullScreenModalLayout.Content = FullScreenModalLayoutContent;
FullScreenModalLayout.Footer = FullScreenModalLayoutFooter;

export { FullScreenModalLayout };
